import React from "react";
import "./PassengerCountMismatchDialog.css";

const PassengerCountMismatchDialog = ({
  isOpen,
  onClose,
  onRejectBMSCount,
  onUpdateAirlineCount,
  passengerData = {},
}) => {
  if (!isOpen) return null;

  const { bmsCount = 0, exempted = 0, billableCount = 0 } = passengerData;

  return (
    <div className="passenger-mismatch-modal-overlay">
      <div className="passenger-mismatch-modal-content">
        <div className="passenger-mismatch-modal-header">
          <button className="passenger-mismatch-modal-close" onClick={onClose}>
            ×
          </button>
        </div>

        <div className="passenger-mismatch-modal-body">
          <h2 className="passenger-mismatch-title">
            Boarded passenger count does not match the BMS passenger count.
          </h2>
          {/* TODO: This will be removed or finalized after confirmation. */}
          {/* <div className="passenger-mismatch-details">
            <div className="passenger-mismatch-detail-row">
              <span className="passenger-mismatch-label">BMS Count:</span>
              <span className="passenger-mismatch-value">{bmsCount}</span>
            </div>
            <div className="passenger-mismatch-detail-row">
              <span className="passenger-mismatch-label">Exempted:</span>
              <span className="passenger-mismatch-value">{exempted}</span>
            </div>
            <div className="passenger-mismatch-detail-row">
              <span className="passenger-mismatch-label">Billable Count:</span>
              <span className="passenger-mismatch-value">{billableCount}</span>
            </div>
          </div> */}
          <div className="passenger-mismatch-actions">
            <button
              className="passenger-mismatch-button reject-bms-button"
              onClick={onRejectBMSCount}
            >
              Dispute BMS Passenger Count
            </button>
            <button
              className="passenger-mismatch-button update-airline-button"
              onClick={onUpdateAirlineCount}
            >
              Correct Boarded Passenger Count
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PassengerCountMismatchDialog;
